module.exports = __webpack_public_path__ + "img/unnamed.56e96751.png";